import { combineSlices } from "@reduxjs/toolkit";

import { watchwordsCategoriesSlice } from "./categories/watchwordsCategoriesSlice";
import { editWatchwordsSlice } from "./edit/editWatchwordsSlice";
import { watchwordsLanguagesSlice } from "./languages/watchwordsLanguagesSlice";
import { watchwordsListSlice } from "./list/watchwordsListSlice";

export default combineSlices(
  editWatchwordsSlice,
  watchwordsCategoriesSlice,
  watchwordsLanguagesSlice,
  watchwordsListSlice
);
